import debug from 'debug';
const logQuery = debug('SPARQL');
const logQueryError = logQuery.extend('error');

function buildAndRun(builder, clientExecute, requestInit) {
  const query = builder.build(requestInit);
  logQuery(query);

  try {
    return clientExecute(query, requestInit);
  } catch (e) {
    logQueryError('Failed query %s', query);
    throw e;
  }
}

export const update = {
  execute(client, requestInit) {
    return buildAndRun(this, client.update.bind(client), requestInit);
  }

};
export const ask = {
  execute(client, requestInit) {
    return buildAndRun(this, client.ask.bind(client), requestInit);
  }

};
export const select = {
  execute(client, requestInit) {
    return buildAndRun(this, client.select.bind(client), requestInit);
  }

};
export const graph = {
  execute(client, requestInit) {
    return buildAndRun(this, client.construct.bind(client), requestInit);
  }

};